// @flow
import React from 'react';
import ItemInstructions from '../item/Instructions';
import ItemQR from '../item/QR';
import ItemBidHistory from '../item/BidHistory';
import ItemAboutShipping from '../item/AboutShipping';
import ItemQuestions from '../item/Questions';
import ItemHowToBid from '../item/HowToBid';
import { ITEM_DETAIL_MODAL_TYPE } from '../item/constants';
import AuctionSchedule from '../auction/Schedule';
import AuctionHowToAttend from '../auction/HowToAttend';
import AuctionQuestions from '../auction/Questions';
import { AUCTION_DETAIL_MODAL_TYPE } from '../auction/constants';

export const selectModalContent = (modalType: string) => {
  switch (modalType) {
    case ITEM_DETAIL_MODAL_TYPE.INSTRUCTIONS:
      return <ItemInstructions />;
    case ITEM_DETAIL_MODAL_TYPE.QR:
      return <ItemQR />;
    case ITEM_DETAIL_MODAL_TYPE.BID_HISTORY:
      return <ItemBidHistory />;
    case ITEM_DETAIL_MODAL_TYPE.ABOUT_SHIPPING:
      return <ItemAboutShipping />;
    case ITEM_DETAIL_MODAL_TYPE.QUESTIONS:
      return <ItemQuestions />;
    case ITEM_DETAIL_MODAL_TYPE.HOW_TO_BID:
      return <ItemHowToBid />;
    case AUCTION_DETAIL_MODAL_TYPE.SCHEDULE:
      return <AuctionSchedule />;
    case AUCTION_DETAIL_MODAL_TYPE.HOW_TO_ATTEND:
      return <AuctionHowToAttend />;
    case AUCTION_DETAIL_MODAL_TYPE.QUESTIONS:
      return <AuctionQuestions />;
    default:
      return null;
  }
};



// WEBPACK FOOTER //
// ./src/services/modal/utils.js